import React from "react";
import {observer} from "mobx-react-lite";
import systemStore from "../storage/SystemStore";
const Btn = ({className, ...rest}) => {
    return (
        <button
            type="button"
            className={className}
            disabled={systemStore.loading}
            {...rest}
        />
    )
}

export default observer(Btn)